/**
 * BenchmarkBadge — compact "validated: nDCG@5 98.7%" pill.
 *
 * Appears in the Home page hero. Links out to the auto-generated baseline
 * report on GitHub so visitors can audit the number and the dataset behind
 * it. Numbers come from `apps/web/src/data/benchmark.ts`, which is
 * auto-generated by every bench run — so this badge always reflects the
 * current committed benchmark.
 */

import { CheckCircle2, ExternalLink } from "lucide-react";

import { BENCHMARK_SUMMARY } from "@/data/benchmark";

export function BenchmarkBadge() {
  const pct = (BENCHMARK_SUMMARY.metrics.ndcgAt5 * 100).toFixed(1);
  const precision = (BENCHMARK_SUMMARY.metrics.precisionAt1 * 100).toFixed(0);

  return (
    <a
      href={BENCHMARK_SUMMARY.baselineReportUrl}
      target="_blank"
      rel="noreferrer"
      className="group inline-flex items-center gap-2.5 px-4 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-300 hover:bg-emerald-500/15 hover:border-emerald-500/50 transition text-xs"
    >
      <CheckCircle2 className="w-3.5 h-3.5 flex-shrink-0" />
      <span className="font-semibold">
        Validated: {pct}% nDCG@5
      </span>
      <span className="text-emerald-300/60">·</span>
      <span className="text-emerald-200/80">
        {precision}% P@1 · {BENCHMARK_SUMMARY.queryCount} queries ·{" "}
        {BENCHMARK_SUMMARY.matchCount} matches
      </span>
      <ExternalLink className="w-3 h-3 flex-shrink-0 opacity-60 group-hover:opacity-100 transition" />
    </a>
  );
}
